/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseTemplateDto } from '../../models/base-template-dto';

export interface GetTemplate$Params {
  id: string;
}

export function getTemplate(http: HttpClient, rootUrl: string, params: GetTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, getTemplate.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseTemplateDto>;
    })
  );
}

getTemplate.PATH = '/v0/templates/{id}';
